import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { Typography } from "../Typography/Typography";

export const StyledDiv = styled.div<{ $multiline?: boolean }>`
  ${FontStyle}
  ${BoxSizingStyle}



  ${tw`tw-relative tw-inline-block tw-max-w-full`}
  ${({ $multiline }) =>
    $multiline &&
    css`
      position: relative;
      display: flex;
    `}
`;

export const StyledSpan = styled(Typography)<{ $disabled?: boolean }>`
  visibility: hidden;
  display: block;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
  position: relative;
  border: 1px solid transparent;
  border-radius: 6px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  font-variant-numeric: tabular-nums;

  ${({ $disabled }) =>
    $disabled &&
    css`
      visibility: visible;
      cursor: default !important;
    `}

  ${({ invalid }) =>
    invalid &&
    css`
      border: 1px solid var(--red-alert);
    `}

  &:empty:before {
    content: " ";
  }
`;

StyledSpan.displayName = "StyledSpan";

export const StyledInput = styled(Typography)`
  ${tw`
    tw-absolute
    tw-inset-0
    tw-border
    tw-border-transparent
    tw-border-solid
    focus-within:tw-border-theme-700
    tw-rounded-md
    tw-box-border
    tw-overflow-hidden
    tw-whitespace-nowrap
    focus-within:tw-overflow-scroll
    tw-w-full`}

  background-color: inherit;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
  &:focus-whitin {
    text-overflow: clip;
  }
  outline-width: 0px;
  outline: none;
  &:disabled {
    opacity: 0;
  }

  &:not([data-hover-suppressed]):hover {
    border-color: var(--color-theme-700);
  }

  ${({ invalid }) =>
    invalid &&
    css`
      border-color: var(--red-alert) !important;
    `}
`;

StyledInput.displayName = "StyledInput";

export const StyledMultilineSpan = styled(StyledSpan)`
  cursor: ${({ $disabled }) => ($disabled ? "default" : "text !important")};
  z-index: 2;
  width: 100%;
  visibility: visible !important;

  &:hover {
    border-color: ${({ invalid, $disabled }) =>
      invalid
        ? "var(--red-alert)"
        : $disabled
        ? "transparent"
        : "var(--border-primary)"};
  }
`;

StyledMultilineSpan.displayName = "StyledMultilineSpan";

export const StyledTextareaSpan = styled(Typography)`
  ${tw`
    tw-absolute
    tw-inset-0
    tw-border
    tw-border-solid
    tw-rounded-md
    tw-box-border
    tw-w-full`}

  background-color: var(--input-background-color);
  border-color: var(--color-theme-500);
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 1px;
  padding-bottom: 1px;
  font-variant-numeric: tabular-nums;
  outline-width: 0px;
  outline: none;
  resize: none;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  height: calc(1.5em * 3 + 2px); /* 3 rows height: line-height * 3 + padding */
  min-height: calc(1.5em * 3 + 2px);
  opacity: 0;
  pointer-events: none;
  z-index: 1;

  &:focus {
    opacity: 1;
    pointer-events: auto;
    background-color: var(--input-background-color);
    border-color: var(--color-primary);
    outline: none;
    z-index: 3;
  }

  &:disabled {
    opacity: 0;
    pointer-events: none;
  }

  ${({ invalid }) =>
    invalid &&
    css`
      border-color: var(--red-alert) !important;
    `}
`;

StyledTextareaSpan.displayName = "StyledTextareaSpan";
